<template>
 <transition name="fade">
  <div class="open-insafari_Wrapper" @click="closeModal">
    <div class="pay_remind_arrow">
       <img  src="../../assets/images/pay_remind_arrow@3x.png" >
    </div>
    <div class="notice-content">
      <p>当前浏览器不支持此</p>
      <p>支付方式，请选择</p>
      <p>『在Safari中打开』继续</p>
    </div>
    <img class="pay_remind_pic"  src="../../assets/images/pay_remind_pic@3x.png" >
  </div>
 </transition>
</template>

<script>
export default {
  name:'openinsafari',
  methods:{
    closeModal(){
      this.$store.commit('changeNotice')
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s
}
.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/modules/OpenInsafari.vue